import { appendToClassName } from "lib/helpers";

interface Props {
  titles: string[];
  data: string[][];
  className?: string;
}

export default function GridTable(props: Props) {
  const { titles, data, className } = props;

  return (
    <>
      <div className={appendToClassName("grid-table", className)}>
        <table>
          <thead>
            <tr>
              {titles.map((title, col) => (
                <th key={`title-${col}`}>{title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={`row-${i}`}>
                {row.map((col, j) => (
                  <td key={`col-${j}`}>{col}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
